const locale = require('./emailViewerModal.i18n.json');

/*@ngInject*/
const EmailViewerModalController = function ($rootScope, $scope, $sce, $window, modalUtil, attachmentUtil, coreConstant, options) {

    $scope.i18n = locale;

    $scope.emailViewModel = {
        email: options.email,
        emailBody: $sce.trustAsHtml(options.email.body)
    };

    $scope.emailTypePlaceholder = $scope.i18n.emailTypePlaceholder;

    $scope.getTitle = function () {
        let title = $scope.emailViewModel.email.subject.substr(0, 75);
        if ($scope.emailViewModel.email.subject.length > 75) {
            title += '...';
        }
        return title;
    };

    $scope.onReplyClick = function () {
        options.replyEmail(options.email.id);
        $scope.$close();
    };

    $scope.onReplyAllClick = function () {
        options.replyAllEmail(options.email.id);
        $scope.$close();
    };

    $scope.onForwardClick = function () {
        options.forwardEmail(options.email.id);
        $scope.$close();
    };

    $scope.isUnderwriterUser = function () {
        return options.isUnderwriterUser === true;
    };

    $scope.canCreateEmail = function () {
        return options.canCreateEmail === true;
    };

    $scope.canDeleteEmail = function () {
        return $scope.isUnderwriterUser() && options.canDeleteEmail && options.email.origin==='UPLOAD';
    };

    $scope.onDeleteClick = function () {
        let config = {
            cancelButtonLabel: $scope.i18n.cancel,
            confirmActionButtonLabel: $scope.i18n.confirm,
            summary: $scope.i18n.deleteConfirmationMessage,
            title: $scope.i18n.deleteConfirmationTitle
        };

        modalUtil.showGenericConfirm(config).then(() => {
            options.deleteEmail(options.email);
            $scope.$close();
        });
    };

    $scope.onUpdateSelectedType = function () {
        let email = $scope.emailViewModel.email;

        if ($scope.emailViewModel.selectedEmailType) {
            email.type = $scope.emailViewModel.selectedEmailType.name;
        }
        else {
            email.type = null;
        }

        options.saveEmail(email, /*savedFromViewer*/true);
    };

    $scope.onAttachmentDownloadClick = (attachment) => {
        attachmentUtil.getAttachmentLinkURL(attachment.id, attachment.name).then((url) => {
            $window.open(url, '_blank');
        });
    };

    attachmentUtil.getAttachmentTypes().then(function (result) {
        $scope.emailViewModel.typeDataItems = result;
        $scope.emailViewModel.selectedEmailType = _.find(result, {name: options.email.type});
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('emailViewerModalController', EmailViewerModalController);
